import { render, staticRenderFns } from "./FashionStore.vue?vue&type=template&id=a8f6ed1e&scoped=true"
import script from "./FashionStore.vue?vue&type=script&lang=js"
export * from "./FashionStore.vue?vue&type=script&lang=js"
import style0 from "./FashionStore.vue?vue&type=style&index=0&id=a8f6ed1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f6ed1e",
  null
  
)

export default component.exports